// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17yRb","rootNoMargin":"styles_rootNoMargin__1FE92"};